import React, { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaGithub } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "config/api";

export default function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/users/signup/`, {
        email,
        password,
      });
      navigate("/sign-in");
    } catch {
      setError("Sign up failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="bg-neutral-900 text-white w-full max-w-md rounded-2xl p-8 shadow-2xl border border-neutral-800">
        <h2 className="text-2xl font-semibold mb-2">Create an account</h2>
        <p className="text-sm text-gray-400 mb-6">
          Enter your email below to create your account
        </p>

        {/* OAuth Buttons */}
        <div className="flex gap-3 mb-5">
          <button className="flex items-center justify-center gap-2 w-1/2 px-4 py-2 border border-neutral-700 rounded-md hover:bg-neutral-800 transition">
            <FaGithub className="text-lg" />
            GitHub
          </button>
          <button className="flex items-center justify-center gap-2 w-1/2 px-4 py-2 border border-neutral-700 rounded-md hover:bg-neutral-800 transition">
            <FcGoogle className="text-lg" />
            Google
          </button>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <div className="h-px flex-1 bg-neutral-800" />
          <span className="text-xs text-gray-500">Or continue with</span>
          <div className="h-px flex-1 bg-neutral-800" />
        </div>

        {error && (
          <p className="text-red-400 text-sm mb-4 text-center">{error}</p>
        )}

        {/* Email */}
        <div className="mb-4">
          <label className="block text-sm mb-1 text-gray-300">Email</label>
          <input
            type="email"
            placeholder="m@example.com"
            className="w-full px-3 py-2 bg-neutral-950 border border-neutral-800 rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-400"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {/* Password */}
        <div className="mb-4">
          <label className="block text-sm mb-1 text-gray-300">Password</label>
          <input
            type="password"
            placeholder="••••••••"
            className="w-full px-3 py-2 bg-neutral-950 border border-neutral-800 rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-400"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {/* Confirm Password */}
        <div className="mb-6">
          <label className="block text-sm mb-1 text-gray-300">
            Confirm Password
          </label>
          <input
            type="password"
            placeholder="••••••••"
            className="w-full px-3 py-2 bg-neutral-950 border border-neutral-800 rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-400"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </div>

        {/* Submit */}
        <button
          onClick={handleSignUp}
          disabled={loading}
          className={`w-full py-2.5 rounded-md font-medium text-black bg-yellow-400 hover:bg-yellow-300 transition ${
            loading ? "opacity-70 cursor-not-allowed" : ""
          }`}
        >
          {loading ? "Creating Account..." : "Create Account"}
        </button>

        <p className="text-sm text-gray-500 text-center mt-4">
          By signing up, you agree to our{" "}
          <a
            href="/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-300"
          >
            Terms
          </a>{" "}
          and{" "}
          <a
            href="/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-300"
          >
            Privacy Policy
          </a>
          .
        </p>

        <p className="text-center text-sm text-gray-400 mt-4">
          Already have an account?{" "}
          <a href="/sign-in" className="text-yellow-400 hover:underline">
            Sign in
          </a>
        </p>
      </div>
    </div>
  );
}